<template>
    <input
        type="radio"
        :name="name"
        :value="value"
        :checked="selected === value"
        v-bind="$attrs"
        v-on="inputListeners"
        @change="$emit('input', value, $event)"
    />
</template>

<script>
import BaseInputComponent from '@/helpers/BaseInputComponent'

export default {
    name: 'oc-radio-input',
    extends: BaseInputComponent,
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        name: {
            required: true,
            type: String
        },
        value: {
            required: true,
            type: [String, Number]
        },
        selected: [String, Number]
    }
}
</script>
